import { render, staticRenderFns } from "./FundosEdit.vue?vue&type=template&id=64507f4d&scoped=true"
import script from "./FundosEdit.vue?vue&type=script&lang=js"
export * from "./FundosEdit.vue?vue&type=script&lang=js"
import style0 from "./FundosEdit.vue?vue&type=style&index=0&id=64507f4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64507f4d",
  null
  
)

export default component.exports